import React from 'react';
import { Field } from 'formik';
import { Form } from 'react-bootstrap';
import { I18n } from "react-redux-i18n";

function TermForm(props) {
    const { label, name, linkTerm, linkPrivacy, fleetName, target, ...rest } = props;

    return (
        <Form.Group>
            <label className={name}>
                {I18n.t("home.I_AGREE_TO", { name: fleetName })}{' '}
                <a
                    href={linkTerm}
                    target={target}
                    className="term-of-service"
                    style={{ display: "inline-block" }}
                >
                    {I18n.t("home.TERMS_OF_USE")}
                </a>
                {' '}{I18n.t("home.AND")}{' '}
                <a
                    href={linkPrivacy}
                    target={target}
                    className="term-of-service"
                    style={{ display: "inline-block" }}
                >
                    {I18n.t("home.PRIVACY_POLICY")}
                </a>
                {' '}{I18n.t("home.I_AGREE_TO_AFTER")}{' '}
            </label>
        </Form.Group>
    )
}

export default TermForm